module.exports = __webpack_public_path__ + "img/termsofservice.8ff59895.png";